import thLocale from 'element-ui/lib/locale/lang/th' //引入element语言包
const th = {
  Login: {
    ToLogin: 'เข้าสู่ระบบ',
    PhoneLogin: 'หมายเลขโทรศัพท์มือถือ เข้าสู่ระบบ',
    EmailLogin: 'เข้าสู่ระบบกล่องจดหมาย',
    PhonePlaceholder: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
    EmailPlaceholder: 'Enter email',
    Code: 'รหัสยืนยัน',
    and: 'และ',
    BeforeText: 'ในขณะที่สร้างบัญชียินยอมและปฏิบัติตามในนามของคุณ',
    UserAgreement: 'ข้อตกลงผู้ใช้',
    privacy: 'นโยบายความเป็นส่วนตัว',
    errorMessage: 'ข้อผิดพลาดของรหัสยืนยัน',
    readTitle: 'อ่านและยอมรับข้อตกลงดังต่อไปนี้',
    readBefore: 'เพื่อรับประกันความปลอดภัยของข้อมูลส่วนบุคคลของคุณโปรดอ่านและยอมรับก่อน',
    cancel: 'การยกเลิก',
    agree: 'เห็นด้วยและดำเนินการต่อไป',
    error1:'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    error2:'กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
    error3:'กรุณากรอกรหัสยืนยัน',
    success:'เข้าสู่ระบบสำเร็จ'
  },
  ...thLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default th;
